"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BezierCurveSegment = void 0;
const bezierToPath_1 = require("./helpers/bezierToPath");
class BezierCurve {
    constructor(segments) {
        this.segments = segments;
    }
    /**
     * Convert this bezier curve into a path string. Which can be used in svg, html or xaml formats.
     * @returns {string} path or xpath
     */
    toPath() {
        return (0, bezierToPath_1.default)(this.segments);
    }
}
exports.default = BezierCurve;
class BezierCurveSegment {
    constructor(start, firstControl, secondControl, end) {
        this.start = start;
        this.end = end;
        this.firstControl = firstControl;
        this.secondControl = secondControl;
    }
    equals(otherCurve) {
        if (!otherCurve)
            return false;
        return (otherCurve.start.equals(this.start) &&
            otherCurve.firstControl.equals(this.firstControl) &&
            otherCurve.secondControl.equals(this.secondControl) &&
            otherCurve.end.equals(this.end));
    }
}
exports.BezierCurveSegment = BezierCurveSegment;
//# sourceMappingURL=BezierCurve.js.map